import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { LogOut, Menu, User, Shield } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const getDashboardLink = () => {
    if (!user) return '/login';
    if (user.role === 'admin' || user.role === 'direction') return '/direction';
    if (user.role === 'agent') return '/agent';
    return '/citoyen';
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-slate-900/95 border-b border-slate-800 text-white" data-testid="main-navbar">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center font-bold text-[#0A192F] text-xl">LS</div>
            <div className="hidden sm:block leading-tight">
              <div className="font-bold text-lg tracking-tight">Lualaba Services</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold">Projet Provincial</div>
            </div>
          </Link>
        </div>

        <nav className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-medium hover:text-blue-200 transition-colors" data-testid="nav-home">Accueil</Link>
          <Link to="/trouver-service" className="text-sm font-medium hover:text-blue-200 transition-colors">Services</Link>
          <Link to="/realisations" className="text-sm font-medium hover:text-blue-200 transition-colors">Réalisations</Link>
          
          {user && (user.role === 'admin' || user.role === 'direction') && (
            <div className="flex gap-4">
              <Link to="/admin/realisations" className="text-sm font-medium hover:text-blue-200 transition-colors text-amber-400">
                CMS Réalisations
              </Link>
              <Link to="/admin/services" className="text-sm font-medium hover:text-blue-200 transition-colors text-amber-400">
                CMS Annuaire
              </Link>
            </div>
          )}
          
          {user ? (
            <div className="flex items-center gap-4 ml-4 pl-4 border-l border-slate-700">
              <Link to={getDashboardLink()} data-testid="nav-dashboard">
                <Button variant="outline" className="bg-slate-800 border-slate-700 hover:bg-slate-700 hover:text-white text-sm h-9">
                  {user.role === 'citoyen' ? <User className="w-4 h-4 mr-2" /> : <Shield className="w-4 h-4 mr-2" />}
                  Mon Espace
                </Button>
              </Link>
              <Button variant="ghost" size="icon" onClick={handleLogout} className="hover:bg-red-900/30 hover:text-red-400 text-slate-400 h-9 w-9" title="Déconnexion" data-testid="nav-logout">
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          ) : (
            <div className="flex items-center gap-3 ml-4 pl-4 border-l border-slate-700">
              <Link to="/login" data-testid="nav-login-btn">
                <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-slate-800 text-sm h-9">Connexion</Button>
              </Link>
              <Link to="/register" data-testid="nav-register-btn">
                <Button className="bg-white hover:bg-slate-200 text-[#0A192F] font-medium text-sm h-9 border-none">Créer un compte</Button>
              </Link>
            </div>
          )}
        </nav>

        <button className="md:hidden p-2 text-slate-300" data-testid="mobile-menu-btn">
          <Menu className="w-6 h-6" />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
